module.exports = __webpack_public_path__ + "img/your_desk.05ddb9a1.png";